// extracted by mini-css-extract-plugin
module.exports = {"worldTaxonomy":"WorldTaxonomy_worldTaxonomy__jE6NW","fixed":"WorldTaxonomy_fixed__4xciF"};